import React from 'react';
const Header = () => {
  return <div className="w-full" data-id="element-78">
      <div className="max-w-4xl mx-auto px-4 py-2 border-b" data-id="element-79">
        <div className="flex items-center justify-between" data-id="element-80">
          {/* MyoQuell Logo and Success Stories */}
          <div className="flex items-start" data-id="element-81">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sgejTjSA1772oc8XhPPtZ8/Copy_of_Natural_Care_Where_Most_Neded_500_x_500_px_1_2_%281%29.png" alt="MyoQuell Herbal Knee Patches" className="h-14 w-auto" data-id="element-82" />
            <span className="text-xs font-medium italic text-green-600 self-end ml-1 mb-1" data-id="element-83">
              Success Stories
            </span>
          </div>
          {/* Desktop navigation */}
          <div className="hidden md:flex space-x-4 text-xs text-gray-600" data-id="element-84">
            <span className="hover:text-green-600 cursor-pointer transition-colors" data-id="element-85">
              Health News
            </span>
            <span className="hover:text-green-600 cursor-pointer transition-colors" data-id="element-86">
              Wellness
            </span>
            <span className="hover:text-green-600 cursor-pointer transition-colors" data-id="element-87">
              Natural Remedies
            </span>
            <span className="hover:text-green-600 cursor-pointer transition-colors" data-id="element-88">
              Reviews
            </span>
          </div>
        </div>
      </div>
    </div>;
};
export default Header;